import { render, staticRenderFns } from "./403.vue?vue&type=template&id=1837a7ec&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=1837a7ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837a7ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1837a7ec')) {
      api.createRecord('1837a7ec', component.options)
    } else {
      api.reload('1837a7ec', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=1837a7ec&scoped=true", function () {
      api.rerender('1837a7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-page/403.vue"
export default component.exports